import { registerDe } from '../i18n/index.js';

registerDe({}, 'EmptyState'); // the three titles live in the shared vocabulary (common.de.ts)
